<template>
  <div class="chat-conversation__loader">
    <div class="chat-conversation__loader-content">
      <loader-circle-icon ref="chatLoader"/>
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap';
import LoaderCircleIcon from '@/assets/icons/loader-circle.svg';

export default {
  components: {
    LoaderCircleIcon,
  },
  mounted() {
    gsap.to(this.$refs.chatLoader, {
      duration: 0.75, rotate: 360, repeat: -1, ease: 'none',
    });
  },
};
</script>
